module.exports = __webpack_public_path__ + "0017fcab5059a50c72c52fb8f2c07192.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg-ucentralcolombia.png
// module id = 1553
// module chunks = 0